import { Link, useLocation } from "react-router-dom";
import { Bug } from "lucide-react";

/**
 * Floating "Report a Bug" pill, mounted globally.
 * Hidden on the Feedback page itself and on admin routes.
 * Sits above the mobile bottom nav (bottom-20 on mobile, bottom-6 on desktop).
 */
const ReportBugButton = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/feedback") || pathname.startsWith("/admin")) {
    return null;
  }

  return (
    <Link
      to="/feedback?category=bug"
      aria-label="Report a bug"
      className="fixed right-4 bottom-20 md:bottom-6 z-40 inline-flex items-center gap-1.5 rounded-full border border-border bg-card/95 backdrop-blur px-3 py-2 text-[11px] font-mono font-semibold text-foreground shadow-lg hover:border-primary/50 hover:text-primary transition-colors"
    >
      <Bug className="w-3.5 h-3.5" />
      <span className="hidden sm:inline">Report a bug</span>
    </Link>
  );
};

export default ReportBugButton;
